<form #formTransfer="ngForm" (ngSubmit)="formTransfer.form.valid && onSubmit()" xmlns="http://www.w3.org/1999/html">
  <section *ngIf="showTargetAccounts">
    <div class="row">
      <div class="col">
        <h3>{{ "accounts.transfers.transfers-title" | translate }}</h3>
      </div>
    </div>
    <ng-container *ngTemplateOutlet="TARGET_ACCOUNTS"></ng-container>
  </section>
  <section *ngIf="showTransfer">
    <ng-container *ngTemplateOutlet="TRANSFER"></ng-container>
  </section>
  <section *ngIf="showOtp">
    <ng-container *ngTemplateOutlet="OTP"></ng-container>
  </section>
  <section *ngIf="showPreDisclosure">
    <ng-container *ngTemplateOutlet="PRE_DISCLOSURE"></ng-container>
  </section>
  <section *ngIf="showDisclosure">
    <ng-container *ngTemplateOutlet="DISCLOSURE"></ng-container>
  </section>
</form>

<ng-template #TARGET_ACCOUNTS>

  <div class="row">
    <div class="col-12">
      <a class="btn btn-primary mb-3" pageScroll [routerLink]="['/account/targetAccount', 'NEW']" [pageScrollOffset]="0" [pageScrollDuration]="300" [pageScrollInterruptible]="false" href="#top_main">
        <i class="fas fa-plus-circle"></i>&nbsp;<span>{{ "accounts.transfers.add-more" | translate }}</span>
      </a>
    </div>

    <div *ngIf="targetAccounts.length > 0" class="col-12">


      <table class="table table-sm table-borderless">
        <thead class="thead-dark">
        <tr>
          <th class="text-center" scope="col"></th>

          <th class="text-center" scope="col">{{ "accounts.transfers.name" | translate }}</th>
          <th class="text-center" scope="col">{{ "accounts.transfers.account" | translate }}</th>
          <th class="text-center" scope="col">{{ "accounts.transfers.actions" | translate }}</th>
        </tr>
        </thead>
        <tbody>
        <ng-container *ngFor="let targetAccount of targetAccounts; let index = index">
          <tr class="transfer-account">

            <td class="edit-col">
              <div class="dropdown">

                <button type="button" class="btn btn-light" (click)="toggleDropdown(index)">
                  <!-- <i class="fa fa-ellipsis-v" aria-hidden="true"></i> -->
                  <i class="fas fa-bars"></i>
                </button>

                <ul class="dropdown-menu" [class.show]="isDropdownOpen[index]" aria-labelledby="dropdownMenuButton">

                  <li>
                    <a pageScroll [routerLink]="['/account/targetAccount', 'EDIT']" [state]="targetAccount" [pageScrollOffset]="0"
                      [pageScrollDuration]="300" [pageScrollInterruptible]="false" href="#top_main">
                      <span class="text-info">
                        {{ "accounts.modal_portals.edit" | translate}}
                        &nbsp;
                        <i class="fas fa-edit"></i>
                      </span>
                    </a>
                  </li>

                  <li (click)="displayDelete = true; deletingAccount=targetAccount; deletingAccountIndex=index; closeAllDropdowns();">
                    <span class="text-danger">
                      {{ "accounts.modal_portals.delete" | translate}}
                      &nbsp;
                      <i class="fas fa-trash"></i>
                    </span>
                  </li>

                </ul>
              </div>
            </td>

            <td class="text-center">
              <div class="align-mobile">
                <strong class="d-block d-md-none">{{ "accounts.transfers.name" | translate }}</strong>
                <span>{{ targetAccount.alias }}</span>
              </div>
            </td>

            <td class="text-center">
              <div class="align-mobile">
                <strong class="d-block d-md-none">{{ "accounts.transfers.account" | translate }}</strong>
                <span>
                  <i class="fas fa-wallet"></i>
                  {{ maskedNumber(targetAccount.accountNumber) }}
                </span>
              </div>
            </td>

            <td class="d-flex justify-content-center align-content-center">
              <div class="btn p-0 ml-1">
                <button type="button" class="btn btn-light"
                        (click)="showTransfer = true; transferDataUpdate(targetAccount)"
                        [disabled]="
                        targetAccount.type == eTargetAccountTypes.INTERNAL_CARD
                          ? !configurations.enableInternalTransfers
                          : !configurations.enableInternationalTransfers">
                  <strong class="text-primary">
                    {{ "accounts.transfers.transfer-text" | translate }}
                    &nbsp;
                    <i class="fa fa-arrow-right" aria-hidden="true"></i>
                  </strong>
                </button>
              </div>
            </td>
          </tr>
        </ng-container>
        </tbody>
      </table>
    </div>

    <div *ngIf="targetAccounts.length === 0" class="col-12">
      <div class="alert alert-info text-center" role="alert">
        <i class="fas fa-info-circle fa-2x"></i>
        <p class="m-0">{{ "accounts.transfers.no-accounts" | translate }}</p>
      </div>
    </div>
  </div>
</ng-template>

<p-dialog header=" " [(visible)]="displayDelete" [modal]="true" [baseZIndex]="10000">
  <div class="d-flex flex-column align-items-center justify-content-center">
    <i class="fas fa-exclamation-circle fa-2x notification-circle-icon"></i>
    <p>{{ "accounts.transfers.deleteAccount" | translate: {Default: "¿Estás seguro de querer eliminarla?"} }}</p>

  </div>
  <div class="d-flex justify-content-between">
    <button type="button" class="btn btn-outline-primary btn-yesno-width" (click)="displayDelete = false">{{ "accounts.transfers.no" | translate}}</button>
    <button type="button" class="btn btn-outline-success ml-3 btn-yesno-width" (click)="deleteAccount();displayDelete = false">{{ "accounts.transfers.yes" | translate}}</button>
  </div>
</p-dialog>

<ng-template #OTP>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-email-title">
      {{ "accounts.transfers.code-info" | translate }}
    </h4>
  </div>
  <div class="modal-body">
    <div class="form-group">
      <label>
        {{ "accounts.transfers.code" | translate }}
      </label>

      <ng-otp-input (onInputChange)="sendTransferConfirm($event)" [config]="{length:otpLength, allowNumbersOnly:true}"></ng-otp-input>
    </div>
  </div>
</ng-template>

<ng-template #TRANSFER id="TRANSFER">
  <div class="d-flex flex-column justify-content-center align-items-center">
    <div *ngIf="transferType === 'INTERNAL'; else international">
      <h2>{{ "accounts.target_account.card_to_card" | translate}}</h2>
    </div>
    <ng-template #international>
      <h2>{{ "accounts.target_account.mex_account" | translate}}</h2>
    </ng-template>

  </div>
  <div class="row justify-content-center mb-2">
    <div class="col-12 col-md-6">
      <div class="card border border-primary">
        <div class="card-body text-center">
          <div class="d-flex flex-row justify-content-center align-items-center">
            <h3>{{ "accounts.transfers.balance" | translate}}</h3>&nbsp;
            <h3>{{(balance <= 0 ? 0 : balance) | currency:'$':'symbol':'1.2':'en'}}</h3>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row justify-content-center mb-2">
    <div class="col-12 col-md-6">
      <div class="card">
        <div class="card-body text-center">
          <div class="d-flex flex-row justify-content-between">
            <h6 class="font-weight-bold">{{ "accounts.transfers.name" | translate}}</h6>
            <p class="small">{{targetAccount.alias}}</p>
          </div>
          <hr class="my-0">
          <div class="d-flex flex-row justify-content-between mt-3">
            <h6 class="font-weight-bold">{{ "accounts.transfers.account" | translate}}</h6>
            <p class="small">{{ maskedNumber(targetAccount.accountNumber) }}</p>
          </div>
          <hr class="my-0">
          <div class="d-flex flex-row justify-content-between mt-3">
            <h6 class="font-weight-bold">{{ "accounts.transfers.transfer-fee" | translate:{Default: "Comisión" } }}</h6>
            <p class="small">{{ transferFee[0]?.amount | currency:'$':'symbol':'1.2':'en'}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-12">
      <div class="form-group">
        <label>{{ "accounts.transaction-history.amount_transfer" | translate}} *</label>

        <input type="text" class="form-control" [allowNegativeNumbers]="false" thousandSeparator="," prefix="$" mask="separator.2" name="transferAmountVal" [(ngModel)]="transferAmount" #transferAmountVal="ngModel" [ngClass]="inputFieldCss(transferAmountVal, formTransfer)" [transferMaximumAmount]="balance - transferFee[0]?.amount" required>
        <app-field-error-display [control]="transferAmountVal" [form]="formTransfer"></app-field-error-display>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-12 text-right mb-2 mt-2">
      <button type="button" class="btn btn-secondary float-left" (click)="this.showTargetAccounts = true; showTransfer = false">
        {{ "accounts.modal_portals.cancel" | translate}}
      </button>
      <button type="submit" class="btn btn-primary" [disabled]="missingExchangeRate || missingTransferFee || !transferAmount || !transferAmountVal.valid">
        {{ "accounts.modal_portals.accept" | translate}}
      </button>
    </div>
  </div>
</ng-template>

<ng-template #PRE_DISCLOSURE>
  <p class="text-center">
    {{ "accounts.transfers.pre-disclosure.advice" | translate }}
  </p>

  <div class="row justify-content-center">
    <div class="col-12 col-md-6">
      <div id="PRE_DISCLOSURE" class="card">
        <div class="card-body">
          <section class="text-center">
            <img src="assets/logos/logo.png" style="width: 100%;max-width: 350px" alt="">
            <p class="m-0 font-weight-bold">Pathward® N.A.</p>
            <p class="m-0">5501 South Broadband Lane</p>
            <p class="m-0">Sioux Falls, South Dakota 57108</p>
          </section>

          <table class="table table-borderless">
            <tr>
              <td class="text-left">
                {{ "accounts.transfers.pre-disclosure.today-text" | translate }}
              </td>

              <td class="text-right">{{today}}</td>
            </tr>
          </table>
          <p class="text-center font-weight-bold">
            {{ "accounts.transfers.pre-disclosure.not-receipt" | translate }}
          </p>

          <table class="table table-borderless">
            <tr>
              <td class="text-left">
                {{ "accounts.transfers.pre-disclosure.amount-send-text" | translate }}
              </td>

              <td class="text-right">{{transferAmount | currency:'$':'symbol':'1.2':'en'}}</td>
            </tr>
            <tr>
              <td class="text-left">
                {{ "accounts.transfers.pre-disclosure.fees-text" | translate }}
              </td>

              <td class="text-right">{{transferFees | currency:'$':'symbol':'1.2':'en'}}</td>
            </tr>
          </table>
          <hr>
          <table class="table table-borderless">
            <tr>
              <td class="text-left">Total</td>
              <td class="text-right">{{transferAmount + transferFees | currency:'$':'symbol':'1.2':'en'}}</td>
            </tr>
            <tr>
              <td class="text-left">
                {{ "accounts.transfers.pre-disclosure.exchange-rate" | translate }}
              </td>

              <td class="text-right">1.00 = {{exchangeRate | currency:'MXN':'symbol':'1.2':'en'}}</td>
            </tr>
          </table>
          <hr>
          <table class="table table-borderless">
            <tr>
              <td class="text-left">
                {{ "accounts.transfers.pre-disclosure.amount-send-text" | translate }}
              </td>
              <td class="text-right">{{transferAmount * exchangeRate | currency:'MXN':'symbol':'1.2':'en'}}</td>
            </tr>
          </table>
          <p class="text-center">
            {{ "accounts.transfers.pre-disclosure.advice-foot" | translate }}
          </p>
        </div>
      </div>
    </div>
  </div>

  <div class=" text-center mt-3">
    <div class="btn-group" role="group">
      <a class="btn btn-secondary mb-4" pageScroll [pageScrollOffset]="0" [pageScrollDuration]="1" [pageScrollInterruptible]="false" href="#top_main" (click)="downloadPreDisclosure()"><i class="fas fa-file-download"></i></a>
      <a class="btn btn-secondary mb-4" pageScroll [pageScrollOffset]="0" [pageScrollDuration]="1" [pageScrollInterruptible]="false" href="#top_main" (click)="openModal(modal_sendPreDisclosure)"><i class="far fa-envelope"></i></a>
    </div>
  </div>
  <div class=" text-center">
    <div class="btn-group" role="group">
      <button type="button" class="btn btn-outline-secondary mb-4" (click)="showPreDisclosure = false; showTransfer = true">
        {{ "accounts.target_account.back" | translate}}
      </button>
      <button type="button" class="btn btn-secondary mb-4" (click)="generateRecaptcha()">
        {{ "accounts.transfers.transfer-text" | translate}}
      </button>
    </div>
  </div>
</ng-template>

<ng-template #DISCLOSURE>
  <div class="row justify-content-center">
    <div class="col-12 col-md-8">
      <div id="DISCLOSURE" class="card">
        <div class="card-body">
          <section class="text-center">
            <img src="assets/logos/logo.png" style="width: 100%;max-width: 350px" alt="">
            <p class="m-0 font-weight-bold">Pathward® N.A.</p>
            <p class="m-0">5501 South Broadband Lane</p>
            <p class="m-0">Sioux Falls, South Dakota 57108</p>
          </section>

          <table class="table table-borderless">
            <tr>
              <td class="text-left">
                {{ "accounts.transfers.pre-disclosure.today-text" | translate }}
              </td>
              <td class="text-right">{{today}}</td>
            </tr>
          </table>
          <p class="text-center font-weight-bold">
            {{ "accounts.transfers.disclosure.remiter-info" | translate }}
          </p>

          <table class="table table-borderless">
            <tr>
              <td class="text-left">
                {{ "accounts.transfers.disclosure.carholders-info" | translate }}
              </td>

              <td class="text-right">{{customerProfile.fullName}}</td>
            </tr>
            <tr>
              <td class="text-left">
                {{ "accounts.transfers.disclosure.account-number" | translate }}
              </td>
              <td class="text-right">{{customerDetail?.mediaAccess?.maskedValue}}</td>
            </tr>
          </table>

          <p class="text-center font-weight-bold">
            {{ "accounts.transfers.disclosure.recipient-info" | translate }}
          </p>

          <hr>
          <p class="text-center m-0">
            {{ "accounts.transfers.disclosure.recipient-name" | translate }}
          </p>
          <p class="text-center">{{targetAccount.firstName}} {{targetAccount.lastName}}</p>

          <table class="table table-borderless">
            <tr>
              <td class="text-left">
                {{ "accounts.transfers.disclosure.local-bank" | translate }}
              </td>
              <td class="text-right">Bankaool</td>
            </tr>
            <tr>
              <td class="text-left">
                {{ "accounts.transfers.disclosure.account-number" | translate }}
              </td>
              <td *ngIf="targetAccount.accountNumber" class="text-right">{{targetAccount.accountNumber.substring(targetAccount.accountNumber.length - 4)}}</td>
            </tr>
          </table>

          <p class="text-center font-weight-bold m-0">
            {{ "accounts.transfers.disclosure.code-confirm" | translate }}
          </p>
          <p class="text-center">{{confirmationCode}}</p>

          <table class="table table-borderless">
            <tr>
              <td class="text-left">
                {{ "accounts.transfers.disclosure.availability" | translate }}
              </td>
              <td class="text-right">{{today}}</td>
            </tr>
            <tr>
              <td class="text-left">
                {{ "accounts.transfers.pre-disclosure.amount-send-text" | translate }}
              </td>
              <td class="text-right">{{transferAmount | currency:'$':'symbol':'1.2':'en'}}</td>
            </tr>
            <tr>
              <td class="text-left">
                {{ "accounts.transfers.pre-disclosure.fees-text" | translate }}
              </td>
              <td class="text-right">+{{transferFees | currency:'$':'symbol':'1.2':'en'}}</td>
            </tr>
          </table>
          <hr>
          <table class="table table-borderless">
            <tr>
              <td class="text-left">Total</td>
              <td class="text-right">{{transferAmount + transferFees | currency:'$':'symbol':'1.2':'en'}}</td>
            </tr>
            <tr>
              <td class="text-left">
                {{ "accounts.transfers.pre-disclosure.exchange-rate" | translate }}
              </td>
              <td class="text-right">1.00 = {{exchangeRate | currency:'MXN':'symbol':'1.2':'en'}}</td>
            </tr>
          </table>
          <hr>
          <table class="table table-borderless">
            <tr>
              <td class="text-left">
                {{ "accounts.transfers.pre-disclosure.amount-send-text" | translate }}
              </td>
              <td class="text-right">{{transferAmount * exchangeRate | currency:'MXN':'symbol':'1.2':'en'}}</td>
            </tr>
          </table>
          <p class="text-center m-0">
            {{ "accounts.transfers.pre-disclosure.advice-foot" | translate }}
          </p>
          <p class="text-center m-0">
            {{ "accounts.transfers.disclosure.advice-foot-2" | translate }}
          </p>
          <p class="text-center m-0">
            {{ "accounts.transfers.disclosure.advice-foot-3" | translate }}
          </p>
          <p class="text-center m-0">
            {{ "accounts.transfers.disclosure.advice-foot-4" | translate }}
          </p>
          <p class="text-center m-0">Consumer Financial Protection Bureau</p>
          <p class="text-center m-0">855-411-2372, 855-729-2372 (TTY/TDD)</p>
          <p class="text-center">consumerfinance.gov</p>
        </div>
      </div>
    </div>
  </div>
  <div class=" text-center mt-3">
    <div class="btn-group" role="group">
      <a class="btn btn-secondary mb-4" pageScroll [pageScrollOffset]="0" [pageScrollDuration]="1" [pageScrollInterruptible]="false" href="#top_main" (click)="downloadDisclosure()"><i class="fas fa-file-download"></i></a>
      <a class="btn btn-secondary mb-4" pageScroll [pageScrollOffset]="0" [pageScrollDuration]="1" [pageScrollInterruptible]="false" href="#top_main" (click)="openModal(modal_sendDisclosure)"><i class="far fa-envelope"></i></a>
    </div>
  </div>
  <div class=" text-center">
    <div class="btn-group" role="group">
      <button type="button" class="btn btn-secondary mb-4" (click)="formTransfer.resetForm(); showDisclosure = false; showTransfer = true; balanceNavigate()">
        {{ "accounts.modal_portals.finish" | translate}}
      </button>
    </div>
  </div>
</ng-template>

<ng-template #modal_sendPreDisclosure let-modal>
  <div class="modal-header">
    <h4 class="modal-title">
      {{ "accounts.transfers.send-by-mail" | translate }}
    </h4>

    send-by-mail
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <p>
      {{ "accounts.transfers.enter-mail" | translate }}
    </p>

    <form #formSenEmail="ngForm" (ngSubmit)="formSenEmail.form.valid && sendPreDisclosure()" novalidate>
      <div class="form-group">
        <label>
          {{ "accounts.personal-data.email" | translate}}
        </label>

        <input type="email" class="form-control" name="email" [(ngModel)]="sendToEmail" #email="ngModel" [ngClass]="inputFieldCss(email, formSenEmail)" email required>
        <app-field-error-display [control]="email" [form]="formSenEmail"></app-field-error-display>
      </div>
      <div class="btn-group">
        <button type="button" class="btn btn-outline-dark" (click)="modal.close()">
          {{ "accounts.modal_portals.cancel" | translate}}
        </button>
        <button type="submit" class="btn btn-outline-dark">
          {{ "accounts.modal_portals.accept" | translate}}
        </button>
      </div>
    </form>
  </div>
</ng-template>

<ng-template #modal_sendDisclosure let-modal>
  <div class="modal-header">
    <h4 class="modal-title">
      {{ "accounts.transfers.send-by-mail" | translate }}
    </h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <p>
      {{ "accounts.transfers.enter-mail" | translate }}
    </p>

    <form #formSenEmail="ngForm" (ngSubmit)="formSenEmail.form.valid && sendDisclosure()">
      <div class="form-group">
        <label>
          {{ "accounts.personal-data.email" | translate}}
        </label>
        <input type="email" class="form-control" name="email" [(ngModel)]="sendToEmail" #email="ngModel" [ngClass]="inputFieldCss(email, formSenEmail)" email required>
        <app-field-error-display [control]="email" [form]="formSenEmail"></app-field-error-display>
      </div>
      <div class="btn-group">
        <button type="button" class="btn btn-outline-dark" (click)="modal.close()">
          {{ "accounts.modal_portals.cancel" | translate}}
        </button>
        <button type="submit" class="btn btn-outline-dark">
          {{ "accounts.modal_portals.accept" | translate}}
        </button>
      </div>
    </form>
  </div>
</ng-template>

<div *ngIf="isAnyDropdownOpen()" class="overlay" (click)="closeAllDropdowns()"></div>
